import React from "react";
import { IntendedUsePageContent } from "@swo/storefront";
import { ContentContainer } from "../../components/_shared-components/arrangement/Container";
import { PageHeadline } from "../../components/_shared-components/ui-elements/PageHeadline";
import { SORichTextRenderer } from "../../components/_shared-components/so-rich-text";
import { FONTS, fontSize } from "../../styles/fonts";
import { css } from "@emotion/react";
import { IntendedUseResultsWithFilter } from "./IntendedUseResultsWithFilter";
import { plainTextStyles } from "../../styles/text-styles";

export const IntendedUseRoot: React.FC<IntendedUsePageContent> = ({ headline, description, items }) => {
  return (
    <>
      <ContentContainer width="narrow" className="u-mb-8">
        <PageHeadline>{headline}</PageHeadline>

        <section
          css={[
            FONTS.SwarovskiFutura300,
            fontSize.x25,
            plainTextStyles,
            css`
              max-width: 36em;
              margin-left: auto;
              margin-right: auto;

              .last-rt-node {
                margin-bottom: 0;
              }
            `,
          ]}
        >
          {description && <SORichTextRenderer richText={description} options={"default"} />}
        </section>
      </ContentContainer>

      <ContentContainer>
        <IntendedUseResultsWithFilter items={items} />
      </ContentContainer>
    </>
  );
};
